// extracted by mini-css-extract-plugin
export default {"requirements":"ng","wrapper":"nh"};